let data = [
	{
		"vuosi": "2016",
		"Kirjailija": "Ilkka Remes",
		"Kirja": "Kiirastuli",
		"Minulla on aikaa": "bussi",
		"Toivon että kirjan maailma on": "jännittävätaipelottava",
		"Kirjan pitää sijoittua": "tulevaisuuteen",
		"Päähenkilö on": "mies",
		"Haluan että kirja": "viihdyttää",
		"nosto-otsikko": "Ilkka Remes: Kiirastuli – Voiko tiedon manipulointi jakaa Suomen kahtia?",
		"nosto-inkku": "Remeksen trilleri edustaa vuotta 2016 Ylen toimittajien valitsemalla itsenäisyyden ajan kirjalistalla.",
		"IMS julkinen ID": "17-7044858492b9622c67",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/12/02/ilkka-remes-kiirastuli-voiko-tiedon-manipulointi-jarkyttaa-yhteiskuntarauhaa"
	},
	{
		"vuosi": "2015",
		"Kirjailija": "Elina Hirvonen",
		"Kirja": "Kun aika loppuu",
		"Minulla on aikaa": "viikonloppu",
		"Toivon että kirjan maailma on": "jännittävätaipelottava ",
		"Kirjan pitää sijoittua": "tulevaisuuteen",
		"Päähenkilö on": "lapsi, nainen",
		"Haluan että kirja": "oivalluksiajayllatyksia",
		"nosto-otsikko": "Elina Hirvonen: Kun aika loppuu – Kuinka ilmastonmuutos vaikuttaa tulevaisuuden ihmisiin?",
		"nosto-inkku": "Lue ekoterrorismia käsittelevä romaani täältä.",
		"IMS julkinen ID": "17-6371557f41da03377a",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/elina-hirvonen-kun-aika-loppuu-kuinka-ilmastonmuutos-vaikuttaa-tulevaisuuden"
	},
	{
		"vuosi": "2014",
		"Kirjailija": "Pajtim Statovci",
		"Kirja": "Kissani Jugoslavia",
		"Minulla on aikaa": "viikonloppu",
		"Toivon että kirjan maailma on": "satu,realismi",
		"Kirjan pitää sijoittua": "1990-2016",
		"Päähenkilö on": "mies,jotainaivanmuuta",
		"Haluan että kirja": "oivalluksiajayllatyksia",
		"nosto-otsikko": "Pajtim Statovci: Kissani Jugoslavia – Miltä suomalaisuus näyttää toisen polven maahanmuuttajan silmin?",
		"nosto-inkku": "Lue ulkopuolisuutta käsittelevä romaani täältä.",
		"IMS julkinen ID": "17-5610357552932c077e",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/pajtim-statovci-kissani-jugoslavia-suomalaisuus-toisen-polven-maahanmuuttajan"
	},
	{
		"vuosi": "2013",
		"Kirjailija": "Pauliina Rauhala",
		"Kirja": "Taivaslaulu",
		"Minulla on aikaa": "viikonloppu",
		"Toivon että kirjan maailma on": "realismi",
		"Kirjan pitää sijoittua": "1990-2016",
		"Päähenkilö on": "nainen",
		"Haluan että kirja": "sivistää ",
		"nosto-otsikko": "Pauliina Rauhala: Taivaslaulu – Koe vanhoillislestadiolainen tragedia",
		"nosto-inkku": "Lue herkkä rakkaustarina täältä.",
		"IMS julkinen ID": "17-6412757fa0c3476672",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/pauliina-rauhala-taivaslaulu-vanhoillislestadiolainen-tragedia"
	},
	{
		"vuosi": "2012",
		"Kirjailija": "Juha Seppälä",
		"Kirja": "Mr. Smith",
		"Minulla on aikaa": "elämä ",
		"Toivon että kirjan maailma on": "realismi",
		"Kirjan pitää sijoittua": "1990-2016 ",
		"Päähenkilö on": "mies",
		"Haluan että kirja": "oivalluksiajayllatyksia",
		"nosto-otsikko": "Juha Seppälä: Mr. Smith – Pakottaako raha luopumaan idealismista?",
		"nosto-inkku": "Lue rahan valtaa käsittelevä romaani täältä.",
		"IMS julkinen ID": "17-6412857fa0ca8dcb8e",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/juha-seppala-mr-smith-pakottaako-raha-luopumaan-idealismista"
	},
	{
		"vuosi": "2011",
		"Kirjailija": "Rosa Liksom",
		"Kirja": "Hytti nro 6",
		"Minulla on aikaa": "viikonloppu",
		"Toivon että kirjan maailma on": "realismi",
		"Kirjan pitää sijoittua": "1990-2016",
		"Päähenkilö on": "nainen,mies",
		"Haluan että kirja": "oivalluksiajayllatyksia",
		"nosto-otsikko": "Rosa Liksom: Hytti nro 6 – Kun eriskummallinen parivaljakko ystävystyy",
		"nosto-inkku": "Kirjassa suuri mies ja hento tyttö matkustavat läpi Siperian. Lue teos täältä.",
		"IMS julkinen ID": "17-6371457f41cc2db7db",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/rosa-liksom-hytti-nro-6-eriskummallisen-parivaljakon-ystavyys"
	},
	{
		"vuosi": "2010",
		"Kirjailija": "Markus Nummi",
		"Kirja": "Karkkipäivä",
		"Minulla on aikaa": "viikonloppu",
		"Toivon että kirjan maailma on": "realismi",
		"Kirjan pitää sijoittua": "1990-2016",
		"Päähenkilö on": "lapsi, mies",
		"Haluan että kirja": "sivistää",
		"nosto-otsikko": "Markus Nummi: Karkkipäivä – Onko hylätty lapsi aikamme kuva?",
		"nosto-inkku": "Lue romaani sosiaalityön tilasta ja lapsen oikeuksista täältä.",
		"IMS julkinen ID": "17-6412957fa0db042a18",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/markus-nummi-karkkipaiva-hylatty-lapsi-ajan-kuvana"
	},
	{
		"vuosi": "2009",
		"Kirjailija": "Maarit Verronen",
		"Kirja": "Normaalia elämää",
		"Minulla on aikaa": "viikonloppu ",
		"Toivon että kirjan maailma on": "realismi ",
		"Kirjan pitää sijoittua": "1990-2016 ",
		"Päähenkilö on": "jotainaivanmuuta",
		"Haluan että kirja": "oivalluksiajayllatyksia",
		"nosto-otsikko": "Maarit Verronen: Normaalia elämää – Oman edun tavoittelu syrjäyttää lähimmäisenrakkauden",
		"nosto-inkku": "Onko tavallisuus sittenkään niin tavallista? Lue novellikokoelma täältä.",
		"IMS julkinen ID": "17-6413057fa0e1bd85d7",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/maarit-verronen-normaalia-elamaa-oman-edun-tavoittelu-syrjayttaa"
	},
	{
		"vuosi": "2008",
		"Kirjailija": "Sofi Oksanen",
		"Kirja": "Puhdistus",
		"Minulla on aikaa": "elämä ",
		"Toivon että kirjan maailma on": "jännittävätaipelottava ",
		"Kirjan pitää sijoittua": "1990-2016,1945-1989",
		"Päähenkilö on": "nainen",
		"Haluan että kirja": "viihdyttää,sivistää",
		"nosto-otsikko": "Sofi Oksanen: Puhdistus – Näe naisiin kohdistuva väkivalta!",
		"nosto-inkku": "Toimittajat Nadja Nowak ja Seppo Puttonen ovat valinneet kirjan jokaiselta Suomen itsenäisyyden vuodelta. Oksasen Puhdistus on vuoden 2008 teos.",
		"IMS julkinen ID": "17-6413157fa0e850d5af",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/sofi-oksanen-puhdistus-naisiin-kohdistuva-vakivalta-nakyvaksi"
	},
	{
		"vuosi": "2007",
		"Kirjailija": "Risto Isomäki",
		"Kirja": "Litium 6",
		"Minulla on aikaa": "bussi",
		"Toivon että kirjan maailma on": "jännittävätaipelottava",
		"Kirjan pitää sijoittua": "tulevaisuuteen",
		"Päähenkilö on": "mies",
		"Haluan että kirja": "viihdyttää",
		"nosto-otsikko": "Risto Isomäki: Litium 6 – Näin ydinvoima uhkaa tulevaisuuttamme",
		"nosto-inkku": "Lue ekologinen trilleri vaarallisista aineista terroristien käsissä täältä.",
		"IMS julkinen ID": "17-6413257fa0edc8dbf8",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/risto-isomaki-litium-6-onko-ydinvoima-uhka-tulevaisuudelle"
	},
	{
		"vuosi": "2006",
		"Kirjailija": "Leena Krohn",
		"Kirja": "Mehiläispaviljonki",
		"Minulla on aikaa": "viikonloppu",
		"Toivon että kirjan maailma on": "satu",
		"Kirjan pitää sijoittua": "tulevaisuuteen",
		"Päähenkilö on": "jotainaivanmuuta",
		"Haluan että kirja": "oivalluksiajayllatyksia",
		"nosto-otsikko": "Leena Krohn: Mehiläispaviljonki – Syvenny sivustakatsojan tutkielmaan ihmisyydestä",
		"nosto-inkku": "Romaanissa kollektiivinen ajattelu on yksilön tahtoa vahvempaa. Lue kirja täältä.",
		"IMS julkinen ID": "17-6413357fa0f2928b65",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/leena-krohn-mehilaispaviljonki-syrjastakatsojan-tutkielma-ihmisyydesta"
	},
	{
		"vuosi": "2005",
		"Kirjailija": "Arto Salminen",
		"Kirja": "Kalavale",
		"Minulla on aikaa": "viikonloppu",
		"Toivon että kirjan maailma on": "realismi",
		"Kirjan pitää sijoittua": "1990-2016",
		"Päähenkilö on": "mies",
		"Haluan että kirja": "oivalluksiajayllatyksia",
		"nosto-otsikko": "Arto Salminen: Kalavale – Miksi ihmiset janoavat julkisuutta?",
		"nosto-inkku": "Työttömiä värvätään television Auschwitz-ohjelmaan. Lue kirja täältä.",
		"IMS julkinen ID": "17-6413457fa0f77c557e",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/arto-salminen-kalavale-visio-tositelevision-kehittymisesta-aarimmaisyyksiin"
	},
	{
		"vuosi": "2004",
		"Kirjailija": "Reko Lundán",
		"Kirja": "Rinnakkain",
		"Minulla on aikaa": "viikonloppu",
		"Toivon että kirjan maailma on": "realismi ",
		"Kirjan pitää sijoittua": "1990-2016 ",
		"Päähenkilö on": "mies",
		"Haluan että kirja": "sivistää",
		"nosto-otsikko": "Reko Lundán: Rinnakkain – Miksi ihmiset eivät halua suvaita erilaisuutta?",
		"nosto-inkku": "Ei minun takapihalleni! Lue romaani keskiluokkaisuudesta täältä.",
		"IMS julkinen ID": "17-6413557fa0fb73e276",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/reko-lundan-rinnakkain-miksi-ihmiset-eivat-halua-suvaita-erilaisuutta"
	},
	{
		"vuosi": "2003",
		"Kirjailija": "Lars Sund",
		"Kirja": "Erikin kirja",
		"Minulla on aikaa": "elämä ",
		"Toivon että kirjan maailma on": "realismi ",
		"Kirjan pitää sijoittua": "1990-2016 ",
		"Päähenkilö on": "mies",
		"Haluan että kirja": "sivistää",
		"nosto-otsikko": "Lars Sund: Erikin kirja – Kuinka Suomesta tuli rauhan tyyssija?",
		"nosto-inkku": "Lue tarina CIA:n vakoojasta ja suomalaisesta tarkka-ampujasta täältä.",
		"IMS julkinen ID": "17-6413657fa1004ebb8c",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/lars-sund-erikin-kirja-suomen-matka-rauhan-tyyssijaksi"
	},
	{
		"vuosi": "2002",
		"Kirjailija": "Kari Hotakainen",
		"Kirja": "Juoksuhaudantie",
		"Minulla on aikaa": "viikonloppu",
		"Toivon että kirjan maailma on": "hauska",
		"Kirjan pitää sijoittua": "1990-2016",
		"Päähenkilö on": "mies",
		"Haluan että kirja": "viihdyttää",
		"nosto-otsikko": "Kari Hotakainen: Juoksuhaudantie – Koe tavallisen suomalaisen miehen kujanjuoksu",
		"nosto-inkku": "Lue kertomus pakkomielteen riivaamasta kotirintamamiehestä täältä.",
		"IMS julkinen ID": "17-6413757fa105839905",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/kari-hotakainen-juoksuhaudantie-tavallisen-suomalaisen-miehen-kujanjuoksu"
	},
	{
		"vuosi": "2001",
		"Kirjailija": "Jari Tervo",
		"Kirja": "Suomemme heimo",
		"Minulla on aikaa": "viikonloppu",
		"Toivon että kirjan maailma on": "hauska",
		"Kirjan pitää sijoittua": "1990-2016 ",
		"Päähenkilö on": "mies",
		"Haluan että kirja": "viihdyttää",
		"nosto-otsikko": "Jari Tervo: Suomemme heimo – Tunne vihamielisyyden alkeet",
		"nosto-inkku": "Rikollisuus on aikamoista söheltämistä Jari Tervon romaanissa. Lue kirja täältä.",
		"IMS julkinen ID": "17-6413857fa10ad7da11",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/jari-tervo-suomemme-heimo-vihamielisyyden-alkeet"
	},
	{
		"vuosi": "2000",
		"Kirjailija": "Jusa Peltoniemi",
		"Kirja": "Jäähyväiset sukuromaanille",
		"Minulla on aikaa": "elämä ",
		"Toivon että kirjan maailma on": "realismi ",
		"Kirjan pitää sijoittua": "1990-2016 ",
		"Päähenkilö on": "mies",
		"Haluan että kirja": "sivistää",
		"nosto-otsikko": "Jusa Peltoniemi: Jäähyväiset sukuromaanille – Kun osaaminen ja työ eivät kohtaa",
		"nosto-inkku": "Lue teos työn tarjonnan ja kysynnän kohtaamattomuudesta  täältä. ",
		"IMS julkinen ID": "17-6413957fa1103758cd",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/jusa-peltoniemi-jaahyvaiset-sukuromaanille-hervoton-satiiri-tyoelaman"
	},
	{
		"vuosi": "1999",
		"Kirjailija": "Veronica Pimenoff",
		"Kirja": "Maa ilman vettä",
		"Minulla on aikaa": "elämä ",
		"Toivon että kirjan maailma on": "realismi",
		"Kirjan pitää sijoittua": "1945-1989 ",
		"Päähenkilö on": "nainen",
		"Haluan että kirja": "sivistää",
		"nosto-otsikko": "Veronica Pimenoff: Maa ilman vettä – Heittäydy elintasokuiluun!",
		"nosto-inkku": "Lue romaani kahtiajakautuneesta maailmasta verkkokirjastosta täältä.",
		"IMS julkinen ID": "17-6414157fa15bfcd5da",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/veronica-pimenoff-maa-ilman-vetta-elintasokuilun-ytimessa"
	},
	{
		"vuosi": "1998",
		"Kirjailija": "Hannu Raittila",
		"Kirja": "Ei minulta mitään puutu",
		"Minulla on aikaa": "elämä",
		"Toivon että kirjan maailma on": "realismi",
		"Kirjan pitää sijoittua": "1990-2016",
		"Päähenkilö on": "nainen,mies",
		"Haluan että kirja": "oivalluksiajayllatyksia",
		"nosto-otsikko": "Hannu Raittila: Ei minulta mitään puutu – Näe jatkuvan kasvun mahdottomuus",
		"nosto-inkku": "Lue romaani suviseurojen tavarapaljoudesta täältä.",
		"IMS julkinen ID": "17-6418557fb52abd0816",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/hannu-raittila-ei-minulta-mitaan-puutu-jatkuvan-kasvun-mahdottomuus"
	},
	{
		"vuosi": "1997",
		"Kirjailija": "Mauri Kunnas",
		"Kirja": "Koiramäen joulukirkko",
		"Minulla on aikaa": "bussi",
		"Toivon että kirjan maailma on": "satu",
		"Kirjan pitää sijoittua": "100000eaa-sodat(1944)",
		"Päähenkilö on": "jotainaivanmuuta",
		"Haluan että kirja": "sivistää",
		"nosto-otsikko": "Mauri Kunnas: Koiramäen joulukirkko – Uppoudu jouluperinteisiin",
		"nosto-inkku": "Lue tarina koiraperheen kirkkomatkasta täältä.",
		"IMS julkinen ID": "17-6418657fb534c6e837",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/mauri-kunnas-koiramaen-joulukirkko-perinteita-ja-joulumielta"
	},
	{
		"vuosi": "1996",
		"Kirjailija": "Kreetta Onkeli",
		"Kirja": "Ilonen talo",
		"Minulla on aikaa": "bussi",
		"Toivon että kirjan maailma on": "realismi",
		"Kirjan pitää sijoittua": "1945-1989",
		"Päähenkilö on": "lapsi",
		"Haluan että kirja": "oivalluksiajayllatyksia ",
		"nosto-otsikko": "Kreetta Onkeli: Ilonen talo – Minkälaista on olla alkoholistin lapsi?",
		"nosto-inkku": "Lue surullisen hauska romaani kotia kaipaavasta tytöstä täältä.",
		"IMS julkinen ID": "17-6418757fb53b9c2abf",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/kreetta-onkeli-ilonen-talo-minkalaista-olla-alkoholistin-lapsi"
	},
	{
		"vuosi": "1995",
		"Kirjailija": "Kalle Päätalo",
		"Kirja": "Hyvästi, Iijoki",
		"Minulla on aikaa": "elämä",
		"Toivon että kirjan maailma on": "realismi",
		"Kirjan pitää sijoittua": "1945-1989",
		"Päähenkilö on": "mies",
		"Haluan että kirja": "sivistää",
		"nosto-otsikko": "Kalle Päätalo: Hyvästi, Iijoki – Tutustu Suomen järeimpään kirjasarjaan",
		"nosto-inkku": "Lue omaelämäkerrallinen tarina Koillismaan historiasta täältä.",
		"IMS julkinen ID": "17-6418957fb547fd67d6",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/kalle-paatalo-hyvasti-iijoki-paatos-yhdelle-maailman-jareimmista-kirjasarjoista"
	},
	{
		"vuosi": "1994",
		"Kirjailija": "Matti Paloheimo",
		"Kirja": "Valkoinen Mandela",
		"Minulla on aikaa": "viikonloppu ",
		"Toivon että kirjan maailma on": "realismi",
		"Kirjan pitää sijoittua": "1990-2016 ",
		"Päähenkilö on": "mies",
		"Haluan että kirja": "oivalluksiajayllatyksia",
		"nosto-otsikko": "Matti Paloheimo: Valkoinen Mandela – Pakolaiskeskuksen johtaja taistelee eriarvoisuutta vastaan",
		"nosto-inkku": "Lue pakolaiskeskuksen johtajan tarina täältä.",
		"IMS julkinen ID": "17-6419557fb58e3592fb",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/matti-paloheimo-valkoinen-mandela-kannanotto-eriarvoisuutta-vastaan"
	},
	{
		"vuosi": "1993",
		"Kirjailija": "Matti Yrjänä Joensuu",
		"Kirja": "Harjunpää ja rakkauden nälkä",
		"Minulla on aikaa": "bussi",
		"Toivon että kirjan maailma on": "jännittävätaipelottava",
		"Kirjan pitää sijoittua": "1990-2016",
		"Päähenkilö on": "mies",
		"Haluan että kirja": "viihdyttää",
		"nosto-otsikko": "Matti Yrjänä Joensuu: Harjunpää ja rakkauden nälkä – Yksinäisellä rikollisella on herkkä tunne-elämä",
		"nosto-inkku": "Lue jännityskirja salaperäisestä hiipparista täältä.",
		"IMS julkinen ID": "17-6419857fb59bde63fd",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/matti-yrjana-joensuu-harjunpaa-ja-rakkauden-nalka-yksinaisen-rikollisen-herkka"
	},
	{
		"vuosi": "1992",
		"Kirjailija": "Daniel Katz",
		"Kirja": "Saksalainen sikakoira",
		"Minulla on aikaa": "elämä",
		"Toivon että kirjan maailma on": "realismi",
		"Kirjan pitää sijoittua": "1990-2016 ",
		"Päähenkilö on": "mies",
		"Haluan että kirja": "oivalluksiajayllatyksia",
		"nosto-otsikko": "Daniel Katz: Saksalainen sikakoira – Tunne Euroopan väkivaltaisen historian perintö",
		"nosto-inkku": "Lue omintakeisen humoristinen teos juutalaisuudesta ja uusnatsismista täältä.",
		"IMS julkinen ID": "17-6419957fb5a25c9ed6",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/daniel-katz-saksalainen-sikakoira-euroopan-vakivaltaisen-historian-perinto"
	},
	{
		"vuosi": "1991",
		"Kirjailija": "Erno Paasilinna",
		"Kirja": "Kauppamiehet isänmaan asialla",
		"Minulla on aikaa": "elämä ",
		"Toivon että kirjan maailma on": "realismi",
		"Kirjan pitää sijoittua": "1990-2016 ",
		"Päähenkilö on": "jotainaivanmuuta",
		"Haluan että kirja": "oivalluksiajayllatyksia,sivistää",
		"nosto-otsikko": "Erno Paasilinna: Kauppamiehet isänmaan asialla – Raakapuheinen esseekokoelma talouden valtarakenteista",
		"nosto-inkku": "Lue kekseliäs kritiikki Euroopan rahavaltiaista täältä.",
		"IMS julkinen ID": "17-6420057fb5a7a909ba",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/erno-paasilinna-kauppamiehet-isanmaan-asialla-raakapuheinen-esseekokoelma"
	},
	{
		"vuosi": "1990",
		"Kirjailija": "Olli Jalonen",
		"Kirja": "Isäksi ja tyttäreksi",
		"Minulla on aikaa": "elämä ",
		"Toivon että kirjan maailma on": "realismi",
		"Kirjan pitää sijoittua": "1990-2016 ",
		"Päähenkilö on": "lapsi,mies",
		"Haluan että kirja": "oivalluksiajayllatyksia",
		"nosto-otsikko": "Olli Jalonen: Isäksi ja tyttäreksi – Kuinka väkivaltainen maailma vaikuttaa lapsiin?",
		"nosto-inkku": "Lue romaani ylisuojelevasta isästä täältä.",
		"IMS julkinen ID": "17-6420157fb5ad978e6c",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/olli-jalonen-isaksi-ja-tyttareksi-vakivaltaisen-maailman-vaikutukset-lapsiin"
	},
	{
		"vuosi": "1989",
		"Kirjailija": "Annika Idström",
		"Kirja": "Kirjeitä Trinidadiin",
		"Minulla on aikaa": "viikonloppu",
		"Toivon että kirjan maailma on": "realismi",
		"Kirjan pitää sijoittua": "1945-1989",
		"Päähenkilö on": "mies,nainen",
		"Haluan että kirja": "oivalluksiajayllatyksia",
		"nosto-otsikko": "Annika Idström: Kirjeitä Trinidadiin – Brutaali taistelu vallasta repii perhettä",
		"nosto-inkku": "Lue romaani lapsen kärsimyksistä  täältä.",
		"IMS julkinen ID": "17-6473258009a5ea9e06",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/annika-idstrom-kirjeita-trinidadiin-brutaali-taistelu-vallasta-repii-perhetta"
	},
	{
		"vuosi": "1988",
		"Kirjailija": "Kari Kontio ja Tuomas Nevanlinna",
		"Kirja": "Kirjava lehmä",
		"Minulla on aikaa": "bussi",
		"Toivon että kirjan maailma on": "hauska",
		"Kirjan pitää sijoittua": "1945-1989",
		"Päähenkilö on": "mies",
		"Haluan että kirja": "sivistää",
		"nosto-otsikko": "Kari Kontio ja Tuomas Nevanlinna: Kirjava lehmä – Eläydy hillittömään vaihtoehtohistoriaan",
		"nosto-inkku": "Lue parodia suomalaisesta historiankirjoituksesta  täältä.",
		"IMS julkinen ID": "17-6473358009b0c67867",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/kari-kontio-ja-tuomas-nevanlinna-kirjava-lehma-hilliton-vaihtoehtohistoria"
	},
	{
		"vuosi": "1987",
		"Kirjailija": "Eeva Kilpi",
		"Kirja": "Animalia",
		"Minulla on aikaa": "bussi",
		"Toivon että kirjan maailma on": "realismi",
		"Kirjan pitää sijoittua": "1945-1989",
		"Päähenkilö on": "jotainaivanmuuta",
		"Haluan että kirja": "oivalluksiajayllatyksia",
		"nosto-otsikko": "Eeva Kilpi: Animalia – Runoilla eläinkokeita vastaan",
		"nosto-inkku": "Lue runokokoelma ihmisen suhteesta luontoon  täältä.",
		"IMS julkinen ID": "17-6473658009bad703a1",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/eeva-kilpi-animalia-kriittinen-myotaelaja-ottaa-kantaa-elainten-puolesta"
	},
	{
		"vuosi": "1986",
		"Kirjailija": "Antti Tuuri",
		"Kirja": "Ameriikan raitti",
		"Minulla on aikaa": "viikonloppu ",
		"Toivon että kirjan maailma on": "realismi ",
		"Kirjan pitää sijoittua": "1945-1989 ",
		"Päähenkilö on": "mies",
		"Haluan että kirja": "viihdyttää",
		"nosto-otsikko": "Antti Tuuri: Ameriikan raitti – Hyväosaisilla veropakolaisilla on moraali höllässä",
		"nosto-inkku": "Lue teos kasinotaloudesta  täältä.",
		"IMS julkinen ID": "17-647385800a0be3b0b2",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/antti-tuuri-ameriikan-raitti-hyvaosaisilla-veropakolaisilla-moraali-hollassa"
	},
	{
		"vuosi": "1985",
		"Kirjailija": "Matti Pulkkinen",
		"Kirja": "Romaanihenkilön kuolema",
		"Minulla on aikaa": "elämä",
		"Toivon että kirjan maailma on": "realismi",
		"Kirjan pitää sijoittua": "1945-1989",
		"Päähenkilö on": "mies",
		"Haluan että kirja": "oivalluksiajayllatyksia",
		"nosto-otsikko": "Matti Pulkkinen: Romaanihenkilön kuolema – Raivokkaan postmoderni antiromaani hämmästyttää lukijansa",
		"nosto-inkku": "Lue kokeellinen teos  täältä.",
		"IMS julkinen ID": "17-647415800a159078a6",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/matti-pulkkinen-romaanihenkilon-kuolema-raivokkaan-postmoderni-antiromaani-yha"
	},
	{
		"vuosi": "1984",
		"Kirjailija": "Pirkko Saisio",
		"Kirja": "Kainin tytär",
		"Minulla on aikaa": "elämä",
		"Toivon että kirjan maailma on": "realismi",
		"Kirjan pitää sijoittua": "1945-1989 ",
		"Päähenkilö on": "nainen",
		"Haluan että kirja": "oivalluksiajayllatyksia",
		"nosto-otsikko": "Pirkko Saisio: Kainin tytär – Minkälaista on naisten välinen rakkaus heteronormatiivisuuden kuristuksessa?",
		"nosto-inkku": "Lue romaani homoseksuaalisuudesta  täältä.",
		"IMS julkinen ID": "17-647455800a2416964d",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/pirkko-saisio-kainin-tytar-naisten-valinen-rakkaus-heteronormatiivisuuden"
	},
	{
		"vuosi": "1983",
		"Kirjailija": "Joni Skiftesvik",
		"Kirja": "Puhalluskukkapoika ja taivaankorjaaja",
		"Minulla on aikaa": "bussi",
		"Toivon että kirjan maailma on": "realismi",
		"Kirjan pitää sijoittua": "1945-1989",
		"Päähenkilö on": "mies,lapsi",
		"Haluan että kirja": "oivalluksiajayllatyksia",
		"nosto-otsikko": "Joni Skiftesvik: Puhalluskukkapoika ja taivaankorjaaja – Eläydy jälleenrakentuvaan Suomeen",
		"nosto-inkku": "Lue novellikokoelma elämästä Pohjois-Suomessa  täältä.",
		"IMS julkinen ID": "17-647485800a2bf31e5a",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/joni-skiftesvik-puhalluskukkapoika-ja-taivaankorjaaja-elaydy-jalleenrakentuvaan"
	},
	{
		"vuosi": "1982",
		"Kirjailija": "Kaari Utrio",
		"Kirja": "Ruusulaakso",
		"Minulla on aikaa": "viikonloppu ",
		"Toivon että kirjan maailma on": "romanttinen ",
		"Kirjan pitää sijoittua": "1945-1989 ",
		"Päähenkilö on": "mies",
		"Haluan että kirja": "viihdyttää",
		"nosto-otsikko": "Kaari Utrio: Ruusulaakso – Aisti yltäkylläisyydestä humaltunut 1980-luku!",
		"nosto-inkku": "Lue parodia menestyjien ajasta  täältä.",
		"IMS julkinen ID": "17-647505800a3ac6b516",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/kaari-utrio-ruusulaakso-yltakyllaisyydesta-humaltunut-1980-luku"
	},
	{
		"vuosi": "1981",
		"Kirjailija": "Anja Kauranen",
		"Kirja": "Sonja O. kävi täällä",
		"Minulla on aikaa": "viikonloppu",
		"Toivon että kirjan maailma on": "realismi",
		"Kirjan pitää sijoittua": "1945-1989",
		"Päähenkilö on": "nainen",
		"Haluan että kirja": "viihdyttää ",
		"nosto-otsikko": "Anja Kauranen: Sonja O. kävi täällä – Kohtaa kokonaista sukupolvea puhutteleva nainen",
		"nosto-inkku": "Lue räväkkä sukupolviromaani täältä.",
		"IMS julkinen ID": "17-647515800a40b83db0",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/anja-kauranen-sonja-o-kavi-taalla-omaa-toimintaansa-sanoittava-nainen"
	},
	{
		"vuosi": "1980",
		"Kirjailija": "Kauko Röyhkä",
		"Kirja": "Tien laidalla Waterloo",
		"Minulla on aikaa": "viikonloppu ",
		"Toivon että kirjan maailma on": "hauska",
		"Kirjan pitää sijoittua": "1945-1989 ",
		"Päähenkilö on": "mies",
		"Haluan että kirja": "oivalluksiajayllatyksia",
		"nosto-otsikko": "Kauko Röyhkä: Tien laidalla Waterloo – Hedonistinen vallankumous vapauttaa!",
		"nosto-inkku": "Lue ylipolitisoituneeseen 1970-lukuun turhautuneista nuorista  täältä.",
		"IMS julkinen ID": "17-647555800a4f69d1f3",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/kauko-royhka-tien-laidalla-waterloo-hedonistinen-vallankumous"
	},
	{
		"vuosi": "1979",
		"Kirjailija": "Asikainen, Melleri, Vuento",
		"Kirja": "Pete Q",
		"Minulla on aikaa": "bussi",
		"Toivon että kirjan maailma on": "satu",
		"Kirjan pitää sijoittua": "1945-1989 ",
		"Päähenkilö on": "jotainaivanmuuta",
		"Haluan että kirja": "viihdyttää",
		"nosto-otsikko": "Asikainen, Melleri, Vuento: Pete Q – Uusi teatterisukupolvi kyseenalaisti perinteet",
		"nosto-inkku": "Lue totalitarismia vastustava näytelmäteksti täältä.",
		"IMS julkinen ID": "17-647575800a5752ecbc",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/asikainen-melleri-vuento-pete-q-uusi-teatterisukupolvi-kyseenalaisti-perinteet"
	},
	{
		"vuosi": "1978",
		"Kirjailija": "Juhani Peltonen",
		"Kirja": "Elmo",
		"Minulla on aikaa": "viikonloppu ",
		"Toivon että kirjan maailma on": "hauska ",
		"Kirjan pitää sijoittua": "1945-1989 ",
		"Päähenkilö on": "mies",
		"Haluan että kirja": "viihdyttää",
		"nosto-otsikko": "Juhani Peltonen: Elmo – Uskotko suomalaiseen urheilijamyyttiin?",
		"nosto-inkku": "Lue urheilusatiiri täältä.",
		"IMS julkinen ID": "17-658475812553453d1c",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/juhani-peltonen-elmo-myytti-voittamattomasta-urheilijasta"
	},
	{
		"vuosi": "1977",
		"Kirjailija": "Paavo Haavikko",
		"Kirja": "Kansakunnan linja",
		"Minulla on aikaa": "elämä",
		"Toivon että kirjan maailma on": "realismi",
		"Kirjan pitää sijoittua": "100000eaa-sodat(1944),1945-1989",
		"Päähenkilö on": "jotainaivanmuuta",
		"Haluan että kirja": "sivistää",
		"nosto-otsikko": "Paavo Haavikko: Kansakunnan linja – Onko suomalaisella historiankirjoituksella todellisuudentajua?",
		"nosto-inkku": "Lue poliittinen tietokirja täältä.",
		"IMS julkinen ID": "17-65848581255b2dab13",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/paavo-haavikko-kansakunnan-linja-todellisuudentajun-palautus-suomalaiseen"
	},
	{
		"vuosi": "1976",
		"Kirjailija": "Risto Rasa",
		"Kirja": "Kaksi seppää",
		"Minulla on aikaa": "bussi",
		"Toivon että kirjan maailma on": "satu",
		"Kirjan pitää sijoittua": "1945-1989 ",
		"Päähenkilö on": "jotainaivanmuuta",
		"Haluan että kirja": " oivalluksiajayllatyksia, viihdyttää",
		"nosto-otsikko": "Risto Rasa: Kaksi seppää – Yhteiskunnallisen luontorunouden edelläkävijä",
		"nosto-inkku": "Lue pelkistetty runokokoelma  täältä.",
		"IMS julkinen ID": "17-658495812563b15acd",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/risto-rasa-kaksi-seppaa-yhteiskunnallisen-luontorunouden-edellakavija"
	},
	{
		"vuosi": "1975",
		"Kirjailija": "Jussi Kylätasku",
		"Kirja": "Revari",
		"Minulla on aikaa": "viikonloppu",
		"Toivon että kirjan maailma on": "realismi ",
		"Kirjan pitää sijoittua": "1945-1989 ",
		"Päähenkilö on": "mies",
		"Haluan että kirja": "sivistää",
		"nosto-otsikko": "Jussi Kylätasku: Revari – Kritiikki 1970-luvun kulttuurieliitin politisoitumisesta",
		"nosto-inkku": "Lue poliittinen aateromaani täältä.",
		"IMS julkinen ID": "17-65850581256a3c5dfa",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/jussi-kylatasku-revari-kritiikki-1970-luvun-kulttuurieliitin-politisoitumisesta"
	},
	{
		"vuosi": "1974",
		"Kirjailija": "Veijo Meri",
		"Kirja": "Kuviteltu kuolema",
		"Minulla on aikaa": "bussi ",
		"Toivon että kirjan maailma on": "realismi",
		"Kirjan pitää sijoittua": "1945-1989 ",
		"Päähenkilö on": "jotainaivanmuuta",
		"Haluan että kirja": "sivistää",
		"nosto-otsikko": "Veijo Meri: Kuviteltu kuolema – Kurkista muuttuvan suomalaisuuden kaleidoskooppiin",
		"nosto-inkku": "Lue monipuolinen tekstikokoelma täältä.",
		"IMS julkinen ID": "17-65851581256fe2d71d",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/veijo-meri-kuviteltu-kuolema-kaleidoskooppi-muuttuvaan-suomalaisuuteen"
	},
	{
		"vuosi": "1973",
		"Kirjailija": "Heikki Turunen",
		"Kirja": "Simpauttaja",
		"Minulla on aikaa": "viikonloppu",
		"Toivon että kirjan maailma on": "hauska, romanttinen",
		"Kirjan pitää sijoittua": "1945-1989 ",
		"Päähenkilö on": "mies",
		"Haluan että kirja": "viihdyttää",
		"nosto-otsikko": "Heikki Turunen: Simpauttaja – Haikea kuvaus maaseudun autioitumisesta",
		"nosto-inkku": "Lue romaani maaseudun autioitumisesta täältä.",
		"IMS julkinen ID": "17-658525812577643ddd",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/heikki-turunen-simpauttaja-hektinen-urbaani-sekoittaa-agraarin-raukeuden"
	},
	{
		"vuosi": "1972",
		"Kirjailija": "Arto Paasilinna",
		"Kirja": "Operaatio Finlandia",
		"Minulla on aikaa": "bussi",
		"Toivon että kirjan maailma on": "hauska",
		"Kirjan pitää sijoittua": "1945-1989",
		"Päähenkilö on": "mies",
		"Haluan että kirja": "viihdyttää, oivalluksiajayllatyksia",
		"nosto-otsikko": "Arto Paasilinna: Operaatio Finlandia – Vihollinen hyökkää lännestä",
		"nosto-inkku": "Lue romaani sodan mielettömyydestä täältä.",
		"IMS julkinen ID": "17-6585358125808a428e",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/arto-paasilinna-operaatio-finlandia-vihollinen-hyokkaa-lannesta"
	},
	{
		"vuosi": "1971",
		"Kirjailija": "Eeva Joenpelto",
		"Kirja": "Vesissä toinen silmä",
		"Minulla on aikaa": "viikonloppu ",
		"Toivon että kirjan maailma on": "realismi",
		"Kirjan pitää sijoittua": "1945-1989 ",
		"Päähenkilö on": "mies",
		"Haluan että kirja": "viihdyttää",
		"nosto-otsikko": "Eeva Joenpelto: Vesissä toinen silmä –  Koe julkisuuden kääntöpuoli",
		"nosto-inkku": "Lue tarina itseään etsivästä elokuvaohjaajasta  täältä.",
		"IMS julkinen ID": "17-6585458125873afbdb",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/eeva-joenpelto-vesissa-toinen-silma-suomalaisen-taiteilijuuden-kipupisteet"
	},
	{
		"vuosi": "1970",
		"Kirjailija": "Lassi Sinkkonen\r\n",
		"Kirja": "Solveigin laulu",
		"Minulla on aikaa": "elämä",
		"Toivon että kirjan maailma on": "realismi",
		"Kirjan pitää sijoittua": "100000eaa-sodat(1944), 1945-1989",
		"Päähenkilö on": "nainen",
		"Haluan että kirja": "viihdyttää",
		"nosto-otsikko": "Lassi Sinkkonen: Solveigin laulu – Vahvojen naisten elämä on kovaa",
		"nosto-inkku": "Lue työläistytön kasvutarina täältä.",
		"IMS julkinen ID": "17-65855581258e0d823b",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/24/lassi-sinkkonen-solveigin-laulu-samaistu-sodan-lapseen"
	},
	{
		"vuosi": "1969",
		"Kirjailija": "Jarkko Laine",
		"Kirja": "Niin kulki Kolumbus",
		"Minulla on aikaa": "viikonloppu ",
		"Toivon että kirjan maailma on": "realismi ",
		"Kirjan pitää sijoittua": "1945-1989",
		"Päähenkilö on": "mies",
		"Haluan että kirja": "oivalluksiajayllatyksia",
		"nosto-otsikko": "Jarkko Laine: Niin kulki Kolumbus – Rock-musiikin kieli tuli kirjallisuuteen",
		"nosto-inkku": "Lue luonteikas nuorisokuvaus täältä.",
		"IMS julkinen ID": "17-65856581260187d05e",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/jarkko-laine-niin-kulki-kolumbus-rock-musiikin-kielenkaytto-tuli-suomeen"
	},
	{
		"vuosi": "1968",
		"Kirjailija": "Tytti Parras",
		"Kirja": "Jojo",
		"Minulla on aikaa": "viikonloppu ",
		"Toivon että kirjan maailma on": "romanttinen ",
		"Kirjan pitää sijoittua": "1945-1989 ",
		"Päähenkilö on": "nainen",
		"Haluan että kirja": "viihdyttää",
		"nosto-otsikko": "Tytti Parras: Jojo – Kenellä on oikeus naisen kehoon?",
		"nosto-inkku": "Lue teos abortista ja seksuaalisesta vapautumisesta täältä.",
		"IMS julkinen ID": "17-65857581260aec6c7c",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/tytti-parras-jojo-kurkista-1960-luvun-opiskelijanaisten-sisimpaan"
	},
	{
		"vuosi": "1967",
		"Kirjailija": "Hannu Salama",
		"Kirja": "Minä, Olli ja Orvokki",
		"Minulla on aikaa": "elämä ",
		"Toivon että kirjan maailma on": "realismi ",
		"Kirjan pitää sijoittua": "1945-1989 ",
		"Päähenkilö on": "mies",
		"Haluan että kirja": "sivistää",
		"nosto-otsikko": "Hannu Salama: Minä, Olli ja Orvokki – Kuinka yhteiskunnan epäoikeudenmukaisuus vaikuttaa taiteeseen?",
		"nosto-inkku": "Lue kirjailijaelämän kuvaus täältä.",
		"IMS julkinen ID": "17-65858581261506e1cc",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/hannu-salama-mina-olli-ja-orvokki-kuinka-yhteiskunnan-epaoikeudenmukaisuus"
	},
	{
		"vuosi": "1966",
		"Kirjailija": "Arvo Salo",
		"Kirja": "Lapualaisooppera",
		"Minulla on aikaa": "bussi",
		"Toivon että kirjan maailma on": "realismi",
		"Kirjan pitää sijoittua": "100000eaa-sodat(1944)",
		"Päähenkilö on": "jotainaivanmuuta",
		"Haluan että kirja": "sivistää",
		"nosto-otsikko": "Arvo Salo: Lapualaisooppera – Pasifistinen vasemmistolaisuuden ikoni",
		"nosto-inkku": "Lue Suomen teatterihistorian kulttiteos täältä.",
		"IMS julkinen ID": "17-65859581261c571c84",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/arvo-salo-lapualaisooppera-rajahdysherkka-aarioikeistolaisuuden-kuvaus"
	},
	{
		"vuosi": "1965",
		"Kirjailija": "Timo K. Mukka",
		"Kirja": "Tabu",
		"Minulla on aikaa": "viikonloppu",
		"Toivon että kirjan maailma on": "romanttinen",
		"Kirjan pitää sijoittua": "1945-1989 ",
		"Päähenkilö on": "nainen,lapsi",
		"Haluan että kirja": "oivalluksiajayllatyksia",
		"nosto-otsikko": "Timo K. Mukka: Tabu – Suomalaisen seksuaalikuvauksen uudistaja",
		"nosto-inkku": "ue pienoisromaani uskonnosta, moraalista ja vastuusta täältä.",
		"IMS julkinen ID": "17-65860581265dcc22e8",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/timo-k-mukka-tabu-suomalaisen-seksuaalikuvauksen-uudistaja"
	},
	{
		"vuosi": "1964",
		"Kirjailija": "Marja-Leena Mikkola",
		"Kirja": "Tyttö kuin kitara",
		"Minulla on aikaa": "viikonloppu ",
		"Toivon että kirjan maailma on": "realismi ",
		"Kirjan pitää sijoittua": "1945-1989 ",
		"Päähenkilö on": "nainen",
		"Haluan että kirja": "oivalluksiajayllatyksia",
		"nosto-otsikko": "Marja-Leena Mikkola: Tyttö kuin kitara – Juurettomuutta ja hetkellistä rakkautta 1960-luvulla",
		"nosto-inkku": "Lue romaani iskelmämuusikoiden elämästä täältä.",
		"IMS julkinen ID": "17-658615812665ec5ad4",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/marja-leena-mikkola-tytto-kuin-kitara-juurettomuus-irrallisuus-ja-satunnaiset"
	},
	{
		"vuosi": "1963",
		"Kirjailija": "Paavo Rintala",
		"Kirja": "Sissiluutnantti",
		"Minulla on aikaa": "elämä ",
		"Toivon että kirjan maailma on": "jännittävätaipelottava ",
		"Kirjan pitää sijoittua": "100000eaa-sodat(1944) ",
		"Päähenkilö on": "mies",
		"Haluan että kirja": "sivistää",
		"nosto-otsikko": "Paavo Rintala: Sissiluutnantti – Mitä sota todella tekee ihmiselle?",
		"nosto-inkku": "Lue epäinhimillinen sotakertomus täältä.",
		"IMS julkinen ID": "17-65862581266b7b0367",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/paavo-rintala-sissiluutnantti-mita-sota-todella-tekee-ihmiselle"
	},
	{
		"vuosi": "1962",
		"Kirjailija": "Pentti Saarikoski",
		"Kirja": "Mitä tapahtuu todella?",
		"Minulla on aikaa": "bussi ",
		"Toivon että kirjan maailma on": "realismi",
		"Kirjan pitää sijoittua": "1945-1989 ",
		"Päähenkilö on": "jotainaivanmuuta",
		"Haluan että kirja": "sivistää",
		"nosto-otsikko": "Pentti Saarikoski: Mitä tapahtuu todella? – Maailma on kaoottinen ja sekava paikka",
		"nosto-inkku": "Lue avantgardistinen runoteos täältä.",
		"IMS julkinen ID": "17-65863581267575dfd2",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/pentti-saarikoski-mita-tapahtuu-todella-runokokoelma-joka-uudisti-suomalaisen"
	},
	{
		"vuosi": "1961",
		"Kirjailija": "Anni Polva",
		"Kirja": "Tiinalla on hyvä sydän",
		"Minulla on aikaa": "bussi",
		"Toivon että kirjan maailma on": "romanttinen",
		"Kirjan pitää sijoittua": "1945-1989 ",
		"Päähenkilö on": "lapsi",
		"Haluan että kirja": "viihdyttää",
		"nosto-otsikko": "Anni Polva: Tiinalla on hyvä sydän – Sodanjälkeisen ydinperheen kuvaus",
		"nosto-inkku": "Lue rohkean koulutytön seikkailu täältä.",
		"IMS julkinen ID": "17-65864581267e309147",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/anni-polva-tiinalla-hyva-sydan-ydinperheen-malli-ja-tyttoyden-hyveet"
	},
	{
		"vuosi": "1960",
		"Kirjailija": "Marja-Liisa Vartio",
		"Kirja": "Kaikki naiset näkevät unia",
		"Minulla on aikaa": "elämä ",
		"Toivon että kirjan maailma on": "realismi ",
		"Kirjan pitää sijoittua": "1945-1989",
		"Päähenkilö on": "nainen",
		"Haluan että kirja": "oivalluksiajayllatyksia",
		"nosto-otsikko": "Marja-Liisa Vartio: Kaikki naiset näkevät unia – Irti turhautuneen naisen elämästä",
		"nosto-inkku": "Lue vaikenevan kotirouvan tarina täältä.",
		"IMS julkinen ID": "17-6586558126845182d3",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/marja-liisa-vartio-kaikki-naiset-nakevat-unia-vaistyvan-naiskuvan-aarella"
	},
	{
		"vuosi": "1959",
		"Kirjailija": "Anders Cleve",
		"Kirja": "Katukiviä",
		"Minulla on aikaa": "bussi ",
		"Toivon että kirjan maailma on": "realismi ",
		"Kirjan pitää sijoittua": "1945-1989 ",
		"Päähenkilö on": "mies",
		"Haluan että kirja": "viihdyttää",
		"nosto-otsikko": "Anders Cleve: Katukiviä – Innostu kaupunkielämän impressionistisista vaikutelmista",
		"nosto-inkku": "Lue tuokiokuvia Helsingin Kalliosta  täältä.",
		"IMS julkinen ID": "17-663235818576a9dd76",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/anders-cleve-katukivia-impressionistisia-vaikutelmia-kaupunkielamasta"
	},
	{
		"vuosi": "1958",
		"Kirjailija": "Aapeli",
		"Kirja": "Pikku Pietarin piha",
		"Minulla on aikaa": "bussi",
		"Toivon että kirjan maailma on": "satu",
		"Kirjan pitää sijoittua": "100000eaa-sodat(1944)",
		"Päähenkilö on": "lapsi",
		"Haluan että kirja": "viihdyttää",
		"nosto-otsikko": "Aapeli: Pikku Pietarin piha – Tapaa äiditön poika 1920-luvun Kuopiossa",
		"nosto-inkku": "Lue koskettava lapsuuden kuvaus  täältä.",
		"IMS julkinen ID": "17-6632758185f110b0ca",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/aapeli-pikku-pietarin-piha-aiditon-poika-1920-luvun-kuopiossa"
	},
	{
		"vuosi": "1957",
		"Kirjailija": "Kirsi Kunnas",
		"Kirja": "Tiitiäisen tarinoita",
		"Minulla on aikaa": "bussi",
		"Toivon että kirjan maailma on": "satu",
		"Kirjan pitää sijoittua": "",
		"Päähenkilö on": "jotainaivanmuuta, lapsi",
		"Haluan että kirja": "viihdyttää",
		"nosto-otsikko": "Kirsi Kunnas: Tiitiäisen tarinoita – Useita sukupolvia kasvattanut hullunkurinen kirja",
		"nosto-inkku": "Lue leikkisä satukokoelma täältä.",
		"IMS julkinen ID": "17-6632858185f923a33f",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/kirsi-kunnas-tiitiaisen-tarinoita-hullunkuriset-sadut-sukupolvien-kasvattajana"
	},
	{
		"vuosi": "1956",
		"Kirjailija": "Irja Virtanen",
		"Kirja": "Kenttäharmaita naisia",
		"Minulla on aikaa": "elämä",
		"Toivon että kirjan maailma on": "jännittävätaipelottava,realismi ",
		"Kirjan pitää sijoittua": "100000eaa-sodat(1944) ",
		"Päähenkilö on": "nainen",
		"Haluan että kirja": "oivalluksiajayllatyksia, sivistää",
		"nosto-otsikko": "Irja Virtanen: Kenttäharmaita naisia – Millaista oli  olla lottana jatkosodassa?",
		"nosto-inkku": "Lue romaani ruumiskentistä ja suhdekiemuroista täältä.",
		"IMS julkinen ID": "17-663295818606625f75",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/irja-virtanen-kenttaharmaita-naisia-kuinka-naiset-kokivat-jatkosodan"
	},
	{
		"vuosi": "1955",
		"Kirjailija": "Rauha S. Virtanen",
		"Kirja": "Seljan tytöt",
		"Minulla on aikaa": "viikonloppu",
		"Toivon että kirjan maailma on": "romanttinen",
		"Kirjan pitää sijoittua": "1945-1989",
		"Päähenkilö on": "lapsi",
		"Haluan että kirja": "viihdyttää",
		"nosto-otsikko": "Rauha S. Virtanen: Seljan tytöt – Eläydy äidittömien tyttärien suhdekiemuroihin",
		"nosto-inkku": "Lue teos siskoksista  täältä.",
		"IMS julkinen ID": "17-66330581860e8bc86b",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/12/02/rauha-s-virtanen-seljan-tytot"
	},
	{
		"vuosi": "1954",
		"Kirjailija": "Väinö Linna",
		"Kirja": "Tuntematon sotilas",
		"Minulla on aikaa": "elämä",
		"Toivon että kirjan maailma on": "jännittävätaipelottava",
		"Kirjan pitää sijoittua": "100000eaa-sodat(1944)",
		"Päähenkilö on": "mies",
		"Haluan että kirja": "sivistää",
		"nosto-otsikko": "Väinö Linna: Tuntematon sotilas – Kohukirjasta kansakunnan kaapin päälle",
		"nosto-inkku": "Lue Linnan läpimurtoteos  täältä.",
		"IMS julkinen ID": "17-6633158186163aaee1",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/vaino-linna-tuntematon-sotilas-suomalaisen-sotakirjallisuuden-klassikko"
	},
	{
		"vuosi": "1953",
		"Kirjailija": "Aino Räsänen",
		"Kirja": "Näkemiin, Helena!",
		"Minulla on aikaa": "viikonloppu ",
		"Toivon että kirjan maailma on": "romanttinen  ",
		"Kirjan pitää sijoittua": "1945-1989 ",
		"Päähenkilö on": "nainen",
		"Haluan että kirja": "viihdyttää",
		"nosto-otsikko": "Aino Räsänen: Näkemiin, Helena! – Koe nuoren sukupolven kaukokaipuu",
		"nosto-inkku": "Lue suosittu ihmissuhderomaani täältä.",
		"IMS julkinen ID": "17-66334581861c64fe50",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/aino-rasanen-nakemiin-helena-nuoren-sukupolven-kaukokaipuu"
	},
	{
		"vuosi": "1952",
		"Kirjailija": "Veikko Huovinen",
		"Kirja": "Havukka-ahon ajattelija",
		"Minulla on aikaa": "bussi",
		"Toivon että kirjan maailma on": "hauska",
		"Kirjan pitää sijoittua": "1945-1989 ",
		"Päähenkilö on": "mies ",
		"Haluan että kirja": "viihdyttää",
		"nosto-otsikko": "Veikko Huovinen: Havukka-ahon ajattelija – Kaukoviisautta, teoreettista viisautta, käytännön viisautta vai jälkiviisautta?",
		"nosto-inkku": "Lue viekkaan humoristinen romaani täältä.",
		"IMS julkinen ID": "17-663355818623368a3c",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/veikko-huovinen-havukka-ahon-ajattelija-metsien-mies-tieteen-ilmioiden-aarella"
	},
	{
		"vuosi": "1951",
		"Kirjailija": "Yrjö Kokko",
		"Kirja": "Sudenhampainen kaulanauha",
		"Minulla on aikaa": "viikonloppu",
		"Toivon että kirjan maailma on": "jännittävätaipelottava",
		"Kirjan pitää sijoittua": "1945-1989",
		"Päähenkilö on": "mies, lapsi",
		"Haluan että kirja": "viihdyttää",
		"nosto-otsikko": "Yrjö Kokko: Sudenhampainen kaulanauha – Voiko Lapin luonto yhdistää isän ja pojan?",
		"nosto-inkku": "Lue tenhoava robinsonadi täältä.",
		"IMS julkinen ID": "17-6633758186293c48d8",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/yrjo-kokko-sudenhampainen-kaulanauha-isa-poika-ja-lapin-luonto"
	},
	{
		"vuosi": "1950",
		"Kirjailija": "Tove Jansson",
		"Kirja": "Muumipapan urotyöt",
		"Minulla on aikaa": "bussi",
		"Toivon että kirjan maailma on": "satu",
		"Kirjan pitää sijoittua": "",
		"Päähenkilö on": "jotainaivanmuuta",
		"Haluan että kirja": "viihdyttää",
		"nosto-otsikko": "Tove Jansson: Muumipapan urotyöt – Heittäydy seikkailuun maalla, merellä ja ilmassa!",
		"nosto-inkku": "Lue kertomus Muumipapan hurjasta elämästä täältä.",
		"IMS julkinen ID": "17-663385818633360914",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/tove-jansson-muumipapan-urotyot-seikkailu-maalla-merella-ja-ilmassa"
	},
	{
		"vuosi": "1949",
		"Kirjailija": "Valentin",
		"Kirja": "Ruma Elsa",
		"Minulla on aikaa": "viikonloppu ",
		"Toivon että kirjan maailma on": "romanttinen ",
		"Kirjan pitää sijoittua": "1945-1989 ",
		"Päähenkilö on": "nainen",
		"Haluan että kirja": "viihdyttää",
		"nosto-otsikko": "Valentin: Ruma Elsa – Millaista oli sukupuoli-identiteetillä leikittely 1940-luvulla?",
		"nosto-inkku": "Lue suomalaista naiseutta hämmentänyt näytelmäteksti täältä.",
		"IMS julkinen ID": "17-6634058186431b80de",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/valentin-ruma-elsa-sukupuoli-identiteetilla-leikittelya-1940-luvulla"
	},
	{
		"vuosi": "1948",
		"Kirjailija": "Elvi Sinervo",
		"Kirja": "Vuorelle nousu",
		"Minulla on aikaa": "bussi ",
		"Toivon että kirjan maailma on": "realismi ",
		"Kirjan pitää sijoittua": "1945-1989 ",
		"Päähenkilö on": "nainen",
		"Haluan että kirja": "oivalluksiajayllatyksia",
		"nosto-otsikko": "Elvi Sinervo: Vuorelle nousu – Nainen taistelee oikeudesta omaan kehoonsa",
		"nosto-inkku": "Lue novellikokoelma naisen taisteluista täältä.",
		"IMS julkinen ID": "17-66342581864b3beb84",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/elvi-sinervo-vuorelle-nousu-naisen-oikeus-omaan-kehoonsa"
	},
	{
		"vuosi": "1947",
		"Kirjailija": "Outsider",
		"Kirja": "Kilroy oli täällä",
		"Minulla on aikaa": "bussi",
		"Toivon että kirjan maailma on": "hauska",
		"Kirjan pitää sijoittua": "1945-1989",
		"Päähenkilö on": "mies",
		"Haluan että kirja": "viihdyttää",
		"nosto-otsikko": "Outsider: Kilroy oli täällä – Kuka oli Kilroy?",
		"nosto-inkku": "Lue arvoituksellinen rikosmysteeri täältä.",
		"IMS julkinen ID": "17-663435818652557a5a",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/outsider-kilroy-oli-taalla-kuka-oli-kilroy"
	},
	{
		"vuosi": "1946",
		"Kirjailija": "Jussi Talvi",
		"Kirja": "Tällaista oli palata",
		"Minulla on aikaa": "elämä",
		"Toivon että kirjan maailma on": "jännittävätaipelottava, realismi",
		"Kirjan pitää sijoittua": "1945-1989",
		"Päähenkilö on": "mies",
		"Haluan että kirja": "sivistää",
		"nosto-otsikko": "Jussi Talvi: Tällaista oli palata – Mitä sota tekee perhesuhteille?",
		"nosto-inkku": "Lue romaani sodasta palaavasta miehestä täältä.",
		"IMS julkinen ID": "17-66344581865c95d996",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/jussi-talvi-tallaista-oli-palata-mita-sota-teki-perhesuhteille"
	},
	{
		"vuosi": "1945",
		"Kirjailija": "Mika Waltari",
		"Kirja": "Sinuhe egyptiläinen",
		"Minulla on aikaa": "elämä",
		"Toivon että kirjan maailma on": "satu",
		"Kirjan pitää sijoittua": "100000eaa-sodat(1944)",
		"Päähenkilö on": "mies",
		"Haluan että kirja": "sivistää, viihdyttää",
		"nosto-otsikko": "Mika Waltari: Sinuhe egyptiläinen – Miksi ihmisten ihanteet eivät toteudu?",
		"nosto-inkku": "Waltarin teos edustaa vuotta 2016 Ylen toimittajien valitsemalla itsenäisyyden ajan kirjalistalla.",
		"IMS julkinen ID": "17-66345581866528135a",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/mika-waltari-sinuhe-egyptilainen-miksi-ihmisten-ihanteet-eivat-toteudu"
	},
	{
		"vuosi": "1944",
		"Kirjailija": "Armas J. Pulla",
		"Kirja": "Jees, leskiyli-insinöörskä! sanoi vääpeli Ryhmy",
		"Minulla on aikaa": "bussi",
		"Toivon että kirjan maailma on": "hauska",
		"Kirjan pitää sijoittua": "100000eaa-sodat(1944)",
		"Päähenkilö on": "mies",
		"Haluan että kirja": "viihdyttää",
		"nosto-otsikko": "Armas J. Pulla: “Jees, leskiyli-insinöörskä!” sanoi vääpeli Ryhmy – Äkkiväärää vinoilua sodasta",
		"nosto-inkku": "Lue valvontakomission hyllyttämä veijaritarina täältä. ",
		"IMS julkinen ID": "17-66346581866a616599",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/armas-j-pulla-jees-leskiyli-insinoorska-sanoi-vaapeli-ryhmy-hupailevaa"
	},
	{
		"vuosi": "1943",
		"Kirjailija": "Matti Hälli",
		"Kirja": "Suopursu kukkii",
		"Minulla on aikaa": "viikonloppu",
		"Toivon että kirjan maailma on": "romanttinen",
		"Kirjan pitää sijoittua": "100000eaa-sodat(1944)",
		"Päähenkilö on": "mies",
		"Haluan että kirja": "viihdyttää",
		"nosto-otsikko": "Matti Hälli: Suopursu kukkii – Elä kaihomielinen rakkaus!",
		"nosto-inkku": "Matti Hällin Suopursu kukkii -romaani tarjoaa pakomatkan ahdistavasta todellisuudesta täältä.",
		"IMS julkinen ID": "17-663475818671991d42",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/10/matti-halli-suopursu-kukkii-suomalaisen-kaihomielisen-rakkauden-ydin "
	},
	{
		"vuosi": "1942",
		"Kirjailija": "Eila Pennanen",
		"Kirja": "Ennen sotaa oli nuoruus",
		"Minulla on aikaa": "viikonloppu ",
		"Toivon että kirjan maailma on": "realismi ",
		"Kirjan pitää sijoittua": "100000eaa-sodat(1944) ",
		"Päähenkilö on": "nainen",
		"Haluan että kirja": "viihdyttää",
		"nosto-otsikko": "Eila Pennanen: Ennen sotaa oli nuoruus – Koe menetetyn tulevaisuuden kaipuu",
		"nosto-inkku": "Lue romaani nuorten peloista ja yhteiskunnallisista ristiriidoista täältä.",
		"IMS julkinen ID": "17-66349581867694e4bf",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/eila-pennanen-ennen-sotaa-oli-nuoruus-koe-menetetyn-tulevaisuuden-kaipuu"
	},
	{
		"vuosi": "1941",
		"Kirjailija": "Helvi Hämäläinen",
		"Kirja": "Säädyllinen murhenäytelmä",
		"Minulla on aikaa": "elämä ",
		"Toivon että kirjan maailma on": "romanttinen ",
		"Kirjan pitää sijoittua": "100000eaa-sodat(1944) ",
		"Päähenkilö on": "nainen",
		"Haluan että kirja": "oivalluksiajayllatyksia",
		"nosto-otsikko": "Helvi Hämäläinen: Säädyllinen murhenäytelmä – Todista yläluokan piittaamattomuuden piirileikki",
		"nosto-inkku": "Lue romaani 1930-luvun eliitistä täältä.",
		"IMS julkinen ID": "17-66350581867bc84125",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/helvi-hamalainen-saadyllinen-murhenaytelma-ylaluokan-piittaamattomuuden"
	},
	{
		"vuosi": "1940",
		"Kirjailija": "Erkki Palolampi",
		"Kirja": "Kollaa kestää",
		"Minulla on aikaa": "elämä ",
		"Toivon että kirjan maailma on": "jännittävätaipelottava ",
		"Kirjan pitää sijoittua": "100000eaa-sodat(1944) ",
		"Päähenkilö on": "mies",
		"Haluan että kirja": "oivalluksiajayllatyksia",
		"nosto-otsikko": "Erkki Palolampi: Kollaa kestää – Mistä suomalainen sotilas sai taistelutahtoa?",
		"nosto-inkku": "Lue ikoninen sotaromaani talvisodasta täältä.",
		"IMS julkinen ID": "17-663515818681eb2cbb",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/10/erkki-palolampi-kollaa-kestaa-sotilaiden-hengennostattaja"
	},
	{
		"vuosi": "1939",
		"Kirjailija": "Hella Wuolijoki",
		"Kirja": "Niskavuoren  leipä",
		"Minulla on aikaa": "elämä ",
		"Toivon että kirjan maailma on": "realismi ",
		"Kirjan pitää sijoittua": "100000eaa-sodat(1944) ",
		"Päähenkilö on": "nainen",
		"Haluan että kirja": "viihdyttää",
		"nosto-otsikko": "Hella Wuolijoki: Niskavuoren leipä – Vahvat naiset ottavat mittaa toisistaan",
		"nosto-inkku": "Lue näytelmä suurtilan matriarkasta täältä.",
		"IMS julkinen ID": "17-66354581868c7dc23a",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/hella-wuolijoki-niskavuoren-leipa-vahvat-naiset-ottavat-mittaa-toisistaan"
	},
	{
		"vuosi": "1938",
		"Kirjailija": "Olavi Paavolainen",
		"Kirja": "Risti ja hakaristi",
		"Minulla on aikaa": "elämä",
		"Toivon että kirjan maailma on": "jännittävätaipelottava ",
		"Kirjan pitää sijoittua": "100000eaa-sodat(1944)",
		"Päähenkilö on": "mies",
		"Haluan että kirja": "sivistää",
		"nosto-otsikko": "Olavi Paavolainen: Risti ja hakaristi – Natsismi näyttää kasvonsa 1930-luvun Suomessa",
		"nosto-inkku": "Lue tietoteos fasismista täältä.",
		"IMS julkinen ID": "17-6635558186936966de",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/olavi-paavolainen-risti-ja-hakaristi-natsismin-kasvot-1930-luvun-suomessa"
	},
	{
		"vuosi": "1937",
		"Kirjailija": "Martti Laine",
		"Kirja": "Kuilu",
		"Minulla on aikaa": "viikonloppu, elämä",
		"Toivon että kirjan maailma on": "jännittävätaipelottava, realismi",
		"Kirjan pitää sijoittua": "100000eaa-sodat(1944)",
		"Päähenkilö on": "mies",
		"Haluan että kirja": "oivalluksiajayllatyksia",
		"nosto-otsikko": "Martti Laine: Kuilu – Millaista oli homomiehen elämä sisällisodassa?",
		"nosto-inkku": "Lue valtavan kalabaliikin herättänyt romaani täältä.",
		"IMS julkinen ID": "17-66356581869862fdba",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/martti-laine-kuilu-homoseksuaalisuus-suomen-sisallissodassa"
	},
	{
		"vuosi": "1936",
		"Kirjailija": "Sally Salminen",
		"Kirja": "Katriina",
		"Minulla on aikaa": "elämä ",
		"Toivon että kirjan maailma on": "realismi ",
		"Kirjan pitää sijoittua": "100000eaa-sodat(1944)",
		"Päähenkilö on": "nainen",
		"Haluan että kirja": "viihdyttää",
		"nosto-otsikko": "Sally Salminen: Katriina – Minkälaista on olla ulkopuolinen?",
		"nosto-inkku": "Lue kansainvälisesti menestynyt romaani ruotsiksi täältä.",
		"IMS julkinen ID": "17-66357581869f41ea2b",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/sally-salminen-katriina-ulkopuolisuutta-ja-sisua-saaristossa"
	},
	{
		"vuosi": "1935",
		"Kirjailija": "Saima Harmaja",
		"Kirja": "Sateen jälkeen",
		"Minulla on aikaa": "bussi",
		"Toivon että kirjan maailma on": "romanttinen, satu",
		"Kirjan pitää sijoittua": "",
		"Päähenkilö on": "nainen",
		"Haluan että kirja": "oivalluksiajayllatyksia, viihdyttää",
		"nosto-otsikko": "Saima Harmaja: Sateen jälkeen – Antaudu tuskan ja kauneuden raastavaan ristiriitaan",
		"nosto-inkku": "Lue koskettava runokokoelma täältä.",
		"IMS julkinen ID": "17-6635858186a51570dc",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/saima-harmaja-sateen-jalkeen-antaudu-sisaisen-tuskan-ja-maailman-kauneuden"
	},
	{
		"vuosi": "1934",
		"Kirjailija": "Katri Vala",
		"Kirja": "Paluu",
		"Minulla on aikaa": "bussi ",
		"Toivon että kirjan maailma on": "satu ",
		"Kirjan pitää sijoittua": "",
		"Päähenkilö on": "nainen",
		"Haluan että kirja": "viihdyttää, oivalluksiajayllatyksia",
		"nosto-otsikko": "Katri Vala: Paluu – Sorrettujen ja lasten ääni kiirii työläiskortteleista",
		"nosto-inkku": "Lue yhteiskunnallinen runokokoelma täältä.",
		"IMS julkinen ID": "17-6635958186b519d7f2",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/katri-vala-paluu-sorrettujen-tyottomien-ja-lasten-aani"
	},
	{
		"vuosi": "1933",
		"Kirjailija": "Joel Lehtonen",
		"Kirja": "Henkien taistelu",
		"Minulla on aikaa": "viikonloppu ",
		"Toivon että kirjan maailma on": "realismi ",
		"Kirjan pitää sijoittua": "100000eaa-sodat(1944) ",
		"Päähenkilö on": "jotainaivanmuuta",
		"Haluan että kirja": "oivalluksiajayllatyksia, sivistää",
		"nosto-otsikko": "Joel Lehtonen: Henkien taistelu – Kyyninen veijariromaani paljastaa salatut paheet",
		"nosto-inkku": "Lue kriittinen ajankuva täältä.",
		"IMS julkinen ID": "17-6636058186bbaaf6a0",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/joel-lehtonen-henkien-taistelu-kyyninen-veijariromaani-pula-ajan-suomesta"
	},
	{
		"vuosi": "1932",
		"Kirjailija": "Toivo Pekkanen",
		"Kirja": "Tehtaan varjossa ",
		"Minulla on aikaa": "elämä ",
		"Toivon että kirjan maailma on": "realismi ",
		"Kirjan pitää sijoittua": "100000eaa-sodat(1944)",
		"Päähenkilö on": "mies",
		"Haluan että kirja": "sivistää",
		"nosto-otsikko": "Toivo Pekkanen: Tehtaan varjossa – Tehdas on yhteiskunta pienoiskoossa",
		"nosto-inkku": "Lue allegorinen työläispojan kasvutarina täältä.",
		"IMS julkinen ID": "17-6636158186c3f4aa09",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/toivo-pekkanen-tehtaan-varjossa-tuotantokoneisto-yhteiskuntajarjestyksen-kuvana"
	},
	{
		"vuosi": "1931",
		"Kirjailija": "Pentti Haanpää",
		"Kirja": "Noitaympyrä",
		"Minulla on aikaa": "viikonloppu",
		"Toivon että kirjan maailma on": "realismi",
		"Kirjan pitää sijoittua": "100000eaa-sodat(1944)",
		"Päähenkilö on": "mies",
		"Haluan että kirja": "sivistää, oivalluksiajayllatyksia",
		"nosto-otsikko": "Pentti Haanpää: Noitaympyrä – Yhteiskuntakritiikki ei kuvia kumartele",
		"nosto-inkku": "Lue luonnonsuojelun edelläkävijäteos täältä.",
		"IMS julkinen ID": "17-6636258186c9de0cc4",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/pentti-haanpaa-noitaympyra-kuvia-kumartelematon-yhteiskuntakritiikki"
	},
	{
		"vuosi": "1930",
		"Kirjailija": "Iris Uurto",
		"Kirja": "Ruumiin ikävä",
		"Minulla on aikaa": "viikonloppu",
		"Toivon että kirjan maailma on": "realismi",
		"Kirjan pitää sijoittua": "100000eaa-sodat(1944)",
		"Päähenkilö on": "nainen",
		"Haluan että kirja": "oivalluksiajayllatyksia",
		"nosto-otsikko": "Iris Uurto: Ruumiin ikävä – Feminismiä suoraan 1930-luvulta",
		"nosto-inkku": "Lue ilmestyessään turmiollisen seksuaaliseksi moitittu romaani täältä.",
		"IMS julkinen ID": "17-6636358186d09d30a3",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/21/iris-uurto-ruumiin-ikava-suomalaisen-feminismin-merkkiteos"
	},
	{
		"vuosi": "1929",
		"Kirjailija": "Aarno Karimo",
		"Kirja": "Kumpujen yöstä",
		"Minulla on aikaa": "elämä",
		"Toivon että kirjan maailma on": "satu",
		"Kirjan pitää sijoittua": "100000eaa-sodat(1944)",
		"Päähenkilö on": "jotainaivanmuuta",
		"Haluan että kirja": "sivistää",
		"nosto-otsikko": "Aarno Karimo: Kumpujen yöstä – Paatoksellinen selitys suomalaisuuden synnystä",
		"nosto-inkku": "Lue mystinen kuvaus Suomen historiasta täältä.",
		"IMS julkinen ID": "17-663645818711ea798c",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/aarno-karimo-kumpujen-yosta-suomi-suureksi"
	},
	{
		"vuosi": "1928",
		"Kirjailija": "Aino Kallas",
		"Kirja": "Sudenmorsian",
		"Minulla on aikaa": "bussi",
		"Toivon että kirjan maailma on": "satu",
		"Kirjan pitää sijoittua": "100000eaa-sodat(1944)",
		"Päähenkilö on": "nainen, jotainaivanmuuta",
		"Haluan että kirja": "viihdyttää, oivalluksiajayllatyksia",
		"nosto-otsikko": "Aino Kallas: Sudenmorsian – Heittäydy riivatun rakkauden syövereihin!",
		"nosto-inkku": "Lue romaani naiseuden muutoksesta täältä.",
		"IMS julkinen ID": "17-66365581871ad909c8",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/aino-kallas-sudenmorsian-heittaydy-riivatun-rakkauden-syovereihin"
	},
	{
		"vuosi": "1927",
		"Kirjailija": "Unto Seppänen",
		"Kirja": "Taakankantajat",
		"Minulla on aikaa": "viikonloppu ",
		"Toivon että kirjan maailma on": "romanttinen ",
		"Kirjan pitää sijoittua": "100000eaa-sodat(1944)",
		"Päähenkilö on": "mies",
		"Haluan että kirja": "viihdyttää",
		"nosto-otsikko": "Unto Seppänen: Taakankantajat – Karjala elää romanttisen urbanistisissa tarinoissa",
		"nosto-inkku": "Lue novellikokoelma 1920-luvun Karjalasta täältä.",
		"IMS julkinen ID": "17-6636758187211c78cf",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/10/unto-seppanen-taakankantajat-romanttisen-urbanistisia-tarinoita-karjalasta"
	},
	{
		"vuosi": "1926",
		"Kirjailija": "Hilja Valtonen",
		"Kirja": "Nuoren opettajattaren varaventtiili",
		"Minulla on aikaa": "bussi, viikonloppu",
		"Toivon että kirjan maailma on": "romanttinen",
		"Kirjan pitää sijoittua": "100000eaa-sodat(1944)",
		"Päähenkilö on": "nainen",
		"Haluan että kirja": "viihdyttää",
		"nosto-otsikko": "Hilja Valtonen: Nuoren opettajattaren varaventtiili – Löydä 1920-luvun villin rohkea naiseus",
		"nosto-inkku": "Lue romanttinen viihderomaani täältä.",
		"IMS julkinen ID": "17-66368581872613f4f9",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/hilja-valtonen-nuoren-opettajattaren-varaventtiili-1920-luvun-villin-rohkea"
	},
	{
		"vuosi": "1925",
		"Kirjailija": "Edith Södergran",
		"Kirja": "Maa jota ei ole ",
		"Minulla on aikaa": "bussi",
		"Toivon että kirjan maailma on": "satu",
		"Kirjan pitää sijoittua": "100000eaa-sodat(1944)",
		"Päähenkilö on": "nainen",
		"Haluan että kirja": "viihdyttää",
		"nosto-otsikko": "Edith Södergran: Maa jota ei ole – Traaginen kosmopoliitti loi uudenlaisen naisen",
		"nosto-inkku": "Lue modernismin airuen runokokoelma täältä.",
		"IMS julkinen ID": "17-66369581872cf7a234",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/10/edith-sodergran-maa-jota-ei-ole-traaginen-kosmopoliitti-loi-uudenlaisen-naisen"
	},
	{
		"vuosi": "1924",
		"Kirjailija": "Maria Jotuni",
		"Kirja": "Tohvelisankarin rouva",
		"Minulla on aikaa": "viikonloppu ",
		"Toivon että kirjan maailma on": "hauska ",
		"Kirjan pitää sijoittua": "100000eaa-sodat(1944)",
		"Päähenkilö on": "nainen",
		"Haluan että kirja": "viihdyttää",
		"nosto-otsikko": "Maria Jotuni: Tohvelisankarin rouva – Miksi ihmisen loputon ahneus naurattaa?",
		"nosto-inkku": "Lue näytelmäteksti valtapelistä täältä.",
		"IMS julkinen ID": "17-663705818734d31a0d",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/maria-jotuni-tohvelisankarin-rouva-komedia-ihmisten-loputtomasta-ahneudesta"
	},
	{
		"vuosi": "1923",
		"Kirjailija": "Kaarlo Hänninen",
		"Kirja": "Kiveliön karkurit",
		"Minulla on aikaa": "elämä",
		"Toivon että kirjan maailma on": "jännittävätaipelottava",
		"Kirjan pitää sijoittua": "100000eaa-sodat(1944)",
		"Päähenkilö on": "mies",
		"Haluan että kirja": "sivistää",
		"nosto-otsikko": "Kaarlo Hänninen: Kiveliön karkurit – Syvenny suomalais-saksalaisen aseveljeyden historiaan",
		"nosto-inkku": "Lue monikulttuurinen rakkaustarina täältä.",
		"IMS julkinen ID": "17-66371581873afa808c",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/kaarlo-hanninen-kivelion-karkurit-suomalais-saksalaisen-aseveljeyden-tuntematon"
	},
	{
		"vuosi": "1922",
		"Kirjailija": "Anni Swan",
		"Kirja": "Pikkupappilassa",
		"Minulla on aikaa": "bussi",
		"Toivon että kirjan maailma on": "romanttinen",
		"Kirjan pitää sijoittua": "100000eaa-sodat(1944)",
		"Päähenkilö on": "lapsi",
		"Haluan että kirja": "viihdyttää",
		"nosto-otsikko": "Anni Swan: Pikkupappilassa – Tytöt ja nuoret naiset ovat itsenäisiä toimijoita",
		"nosto-inkku": "Lue nuortenkirjaklassikko täältä.",
		"IMS julkinen ID": "17-6637258187403ddb8b",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/anni-swan-pikkupappilassa-tytot-ja-nuoret-naiset-itsenaisina-toimijoina"
	},
	{
		"vuosi": "1921",
		"Kirjailija": "Olli",
		"Kirja": "Mustapartainen mies herättää pahennusta",
		"Minulla on aikaa": "bussi",
		"Toivon että kirjan maailma on": "hauska",
		"Kirjan pitää sijoittua": "100000eaa-sodat(1944)",
		"Päähenkilö on": "jotainaivanmuuta",
		"Haluan että kirja": "viihdyttää,oivalluksiajayllatyksia",
		"nosto-otsikko": "Olli: Mustapartainen mies herättää pahennusta – Verbaaliakrobatiaa pikkuporvarillisista säännöistä",
		"nosto-inkku": "Lue kielellisesti monitasoinen pakinakokoelma täältä.",
		"IMS julkinen ID": "17-6637358187470f17d1",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/olli-mustapartainen-mies-herattaa-pahennusta-verbaaliakrobatiaa"
	},
	{
		"vuosi": "1920",
		"Kirjailija": "Juhani Aho",
		"Kirja": "Muistatko?",
		"Minulla on aikaa": "viikonloppu",
		"Toivon että kirjan maailma on": "romanttinen",
		"Kirjan pitää sijoittua": "100000eaa-sodat(1944)",
		"Päähenkilö on": "mies",
		"Haluan että kirja": "sivistää",
		"nosto-otsikko": "Juhani Aho: Muistatko? – Tutustu kirjailijamestarin henkilökohtaisiin onnen hetkiin ja sotamuistoihin",
		"nosto-inkku": "Lue ensimmäisen suomalaisen ammattikirjailijan muistelmateos täältä.",
		"IMS julkinen ID": "17-66374581874e148673",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/juhani-aho-muistatko-onnen-hetkia-ja-sisallissotamuistoja"
	},
	{
		"vuosi": "1919",
		"Kirjailija": "Frans Emil Sillanpää",
		"Kirja": "Hurskas kurjuus",
		"Minulla on aikaa": "elämä",
		"Toivon että kirjan maailma on": "jännittävätaipelottava",
		"Kirjan pitää sijoittua": "100000eaa-sodat(1944)",
		"Päähenkilö on": "mies",
		"Haluan että kirja": "sivistää",
		"nosto-otsikko": "Frans Emil Sillanpää: Hurskas kurjuus – Miksi päädyimme sisällissotaan?",
		"nosto-inkku": "Lue teos ihmiskohtalosta täältä.",
		"IMS julkinen ID": "17-6637558187526d2dd7",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/frans-emil-sillanpaa-hurskas-kurjuus-miksi-paadyimme-veljessotaan"
	},
	{
		"vuosi": "1918",
		"Kirjailija": "Eino Leino",
		"Kirja": "Vapauden kirja",
		"Minulla on aikaa": "bussi",
		"Toivon että kirjan maailma on": "satu, jännittävätaipelottava",
		"Kirjan pitää sijoittua": "100000eaa-sodat(1944)",
		"Päähenkilö on": "jotainaivanmuuta",
		"Haluan että kirja": "sivistää",
		"nosto-otsikko": "Eino Leino: Vapauden kirja – Suvaitsevaisuuden sanansaattaja ottaa kantaa rauhan puolesta",
		"nosto-inkku": "Lue poliittinen runokokoelma ja muut sadan vuoden kirjat täältä.",
		"IMS julkinen ID": "17-66376581875d85cf24",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/eino-leino-vapauden-kirja-suvaitsevaisuuden-sanansaattajan-kannanotto-rauhan"
	},
	{
		"vuosi": "1917",
		"Kirjailija": "Konrad Lehtimäki",
		"Kirja": "Ylös helvetistä ",
		"Minulla on aikaa": "elämä",
		"Toivon että kirjan maailma on": "jännittävätaipelottava",
		"Kirjan pitää sijoittua": "tulevaisuuteen, 100000eaa-sodat(1944)",
		"Päähenkilö on": "mies",
		"Haluan että kirja": "oivalluksiajayllatyksia",
		"nosto-otsikko": "Konrad Lehtimäki: Ylös helvetistä – Voiko rauhan saada aikaan aseilla?",
		"nosto-inkku": "Lue pasifistinen tieteiskuvitelma täältä.",
		"IMS julkinen ID": "17-663775818763b5cf5c",
		"Fynd-artikkelin url": "http://yle.fi/aihe/artikkeli/2016/11/01/konrad-lehtimaki-ylos-helvetista-nakymaton-lentokone-ja-ylivoimainen-pommi"
	}
]

export { data }
